import request from 'api/requestUtils'

export function createQuoteFromCart(cartId: string, callbackDate?: string, utms?: Array<string>) {
  return request.post('/api/carts/quotes', { cartId, callbackDate, utms }, { credentials: 'include' })
}
